import React from "react";
import Hero from "../../Components/Landing/Hero";
import Telehealth from "../../Components/Landing/Telehealth";
import Portals from "../../Components/Landing/Portals";
import Features from "../../Components/Landing/Features";
import Journey from "../../Components/Landing/Journey";
import Benefits from "../../Components/Landing/Benefits";
import Pricing from "../../Components/Landing/Pricing";
import Faq from "../../Components/Landing/Faq";
import Contact from "../../Components/Landing/Contact";

const Home = () => (
  <main>
    <Hero />
    <Telehealth />
    <Portals />
    <Features />
    <Journey />
    <Benefits />
    <Pricing />
    <Faq />
    <Contact />
  </main>
);

export default Home;
